import { useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import ArchiveQuestionConfigModal from 'modules/surveys/components/Questions/ArchiveQuestionConfigModal'

const SurveyArchiveQuestionPage = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()
  const { id, question_config_id } = useParams()

  return (
    <ArchiveQuestionConfigModal
      description={i18n.t('surveys.form.archive.description')}
      formId={id ?? ''}
      questionConfigId={question_config_id ?? ''}
      submit={i18n.t('surveys.form.archive.submit')}
      title={i18n.t('surveys.form.archive.title')}
      onClose={() =>
        navigate(navigation.engagement.surveys.id.questions.fullPath({ id: String(id) }))
      }
    />
  )
}

export default SurveyArchiveQuestionPage
